import { ErrorHandler, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IntercomModule } from '@supy-io/ngx-intercom';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';

import { AppRoutingModule } from './app-routing.module';
import { SidenavMenuComponent } from './layouts/sidenav-menu/sidenav-menu.component';

import { AngularFireModule } from '@angular/fire/compat';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { AngularFireStorageModule } from '@angular/fire/compat/storage';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { ConfirmationDialogComponent } from './common/confirmation-dialog/confirmation-dialog.component';
import { CustomSnackBarComponent } from './common/custom-snack-bar/custom-snack-bar.component';

import { CoreModule } from '@core/core.module';
import { SharedModule } from '@shared/shared.module';
import { HeaderModule } from './header/header.module';

import { QuillModule } from 'ngx-quill';
import { GlobalErrorHandler } from '@shared/error-handling/error-handler';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '@environment/environment';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';
import { metaReducers, reducers } from '@state/core.reducer';
import { coreEffects } from '@state/core.effects';
import { servicesEffects } from './v2/services/services.effects';
import { PendingChangesGuard } from './pending-changes-guard';

import { IConfig, NgxMaskDirective, NgxMaskPipe, provideEnvironmentNgxMask } from 'ngx-mask';
import { ServiceWorkerModule } from '@angular/service-worker';
import { PwaInstallPromptComponent } from './services/pwa/pwa-install-prompt.component';

const maskConfig: Partial<IConfig> = {};

@NgModule({
	declarations: [
		AppComponent,
		SidenavMenuComponent,
		ConfirmationDialogComponent,
		CustomSnackBarComponent,
		PwaInstallPromptComponent,
	],
	imports: [
		BrowserAnimationsModule,
		AppRoutingModule,
		AngularFireModule.initializeApp(environment.firebase),
		AngularFirestoreModule,
		AngularFireAuthModule,
		AngularFireStorageModule,
		AngularFireMessagingModule,
		CoreModule,
		SharedModule,
		CommonModule,
		IntercomModule.forRoot({
			appId: environment.INTERCOM_APP_ID,
			updateOnRouterChange: true,
		}),
		HeaderModule,
		QuillModule.forRoot(),
		StoreModule.forRoot(reducers, {
			metaReducers,
			runtimeChecks: {
				strictActionImmutability: false,
			},
		}),
		EffectsModule.forRoot([...coreEffects, ...servicesEffects]),
		StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production }),
		StoreRouterConnectingModule.forRoot(),
		NgxMaskDirective,
		NgxMaskPipe,
		// ngsw-worker.js registration is handled in main.ts with existence check
		// to prevent request floods when the file doesn't exist (ng serve)
		ServiceWorkerModule.register('ngsw-worker.js', { enabled: false }),
	],
	providers: [
		{
			provide: ErrorHandler,
			useClass: GlobalErrorHandler,
		},
		PendingChangesGuard,
		provideEnvironmentNgxMask(maskConfig),
	],
	bootstrap: [AppComponent],
})
export class AppModule {}
